import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";

import t from "../../i18n/i18n";
import initPage from "../../utils/initPage";
import useApi from "../../services/api";

import Template from "../../template/template";
import Header from "./header/header";
import Notify from "../../components/notification/notify";

function View() {
  initPage({ title: "" });

  const { order, id } = useParams();

  const { ApiGetTicketInfo, ApiSendTicketResponse } = useApi();

  const [response, setResponse] = useState({});
  const [ticket, setTicket] = useState(null);
  const [ableToResponse, setAbleToResponse] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  async function getTicketInfo() {
    const { data } = await ApiGetTicketInfo(id);

    const message = JSON.parse(data.message);

    if (data.responses.length > 0) {
      const lastIsAdmin = data.responses[data.responses.length - 1].user.admin;
      if (lastIsAdmin) {
        setAbleToResponse(true);
      } else {
        setAbleToResponse(false);
      }
    }

    setTicket({ ...data, message });
  }

  useEffect(() => {
    getTicketInfo();
  }, []);

  async function submitForm() {
    if (!response?.message) return Notify({ type: "danger", message: t("Errors.EmptyAnswerResponse") });

    setLoadingSubmit(true);

    await ApiSendTicketResponse(id, response);

    Notify({ type: "success", message: t("Success.AnswerResponse") });

    setLoadingSubmit(false);

    return getTicketInfo();
  }

  return (
    <Template>
      {ticket && (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="support-warp">
                <div className="support-warp-main">
                  <Header />

                  <div className="support-content">
                    {/* <div className="support-search">
                    <h4>PESQUISAR NA CENTRAL DE SUPORTE</h4>
                    <div className="input-text icon-search">
                      <input type="text" value="" pattern="" />
                    </div>
                  </div> */}

                    <div className="support-form">
                      <div className="support-form-header">
                        <h1>
                          {t("Support.TICKET")} {order}
                        </h1>
                      </div>
                      <div className="ticket-warp-box">
                        <div className="ticket-toolbar-top">
                          <div className="toolbar-left">
                            <div className="label-box">
                              <label>{t("Support.View.Status")}</label>
                              <span>
                                {ticket.status !== "closed" ? t("Support.View.Opened") : t("Support.View.Closed")}
                              </span>
                            </div>
                            <div className="label-box">
                              <label>{t("Support.View.TicketId")}</label>
                              <span>#USK{ticket && ticket.id ? ticket?.id.toString().padStart(4, 0) : ""}</span>
                            </div>
                          </div>
                          <div className="toolbar-right">
                            <div className="ticke-date">
                              <label>{t("Support.View.Created")}</label>
                              <span>{moment(ticket.createdAt).format("DD/MM/YYYY")}</span>
                            </div>
                          </div>
                        </div>

                        <ul className="ticket-list-message">
                          <li>
                            <div className="message-box">
                              <div className="message-header">
                                <div className="user-profile-info">
                                  <figure>
                                    <a href="#">
                                      <span className="profile-thumb">
                                        <img src={ticket.user.avatar || "/images/user-thumn-m.png"} alt="" />
                                      </span>
                                      <span className="user-name">{ticket.user.name}</span>
                                    </a>
                                  </figure>
                                </div>
                                <div className="msg-time-info">
                                  <span>{moment(ticket.createdAt).format("DD/MM/YYYY")}</span>
                                </div>
                              </div>
                              <p>{ticket.message.question}</p>
                            </div>
                          </li>

                          {ticket?.responses.map((R) => {
                            return (
                              <li>
                                <div className="message-box">
                                  <div className="message-header">
                                    <div className="user-profile-info">
                                      <figure>
                                        <a href="#">
                                          <span className="profile-thumb">
                                            <img src={R.user.avatar || "/images/user-thumn-m.png"} alt="" />
                                          </span>
                                          <span className="user-name">{R.user.name}</span>
                                        </a>
                                      </figure>
                                    </div>
                                    <div className="msg-time-info">
                                      <span>{moment(R.createdAt).format("DD/MM/YYYY")}</span>
                                    </div>
                                  </div>
                                  <p>{R.message}</p>
                                </div>
                              </li>
                            );
                          })}

                          {ableToResponse && ticket.status !== "closed" && (
                            <li className="last">
                              <div className="message-box">
                                <div className="message-header">
                                  <div className="user-profile-info">
                                    <figure>
                                      <a href="#">
                                        <span className="profile-thumb">
                                          <img src="/images/user-thumb.png" alt="" />
                                        </span>
                                        <span className="user-name">Usuário</span>
                                      </a>
                                    </figure>
                                  </div>
                                </div>

                                <div className="message-textarea">
                                  <textarea
                                    placeholder={t("Support.View.AnswerPlaceholder")}
                                    value={response?.message}
                                    onChange={(e) => setResponse({ message: e.target.value })}
                                  />
                                  <div className="message-btn-right">
                                    <button
                                      disabled={loadingSubmit}
                                      type="button"
                                      className="btn btn-primary message-btn"
                                      onClick={submitForm}
                                    >
                                      {t("Support.View.Answer")}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </li>
                          )}
                        </ul>

                        {/* HERE */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Template>
  );
}

export default View;
